<template>
	<div class="content">
		<div class="container">
			<img src="@/assets/footer/img-main-try-logo.png"
						srcset="@/assets/footer/img-main-try-logo@2x.png 2x,
	 				@/assets/footer/img-main-try-logo@3x.png 3x" class="center"/>
					<p v-html="l10.All_Footer_Title1">

					</p>
					<p  v-html="l10.All_Footer_Title1_Description1_Description1">

					</p>
			<div>
				<template v-if="isAndroid && this.$store.state.lang == 'cn' && this.$store.state.cnDownloadUrl != ''">
					<div id="mobile-store-btn" v-html="l10.All_Footer_Title2" @click="handleClickAndroidDownload"></div>
				</template>
				<template v-else>
					<a :href="downloadUrl" target="_blank">
						<div id="mobile-store-btn" :class="isAndroid ? 'mo_playstore_btn' : 'mo_appstore_btn'" v-html="l10.All_Footer_Title1"></div>
					</a>
				</template>
			</div>
		</div>

	</div>

</template>
<script>
// import JQuery  from 'vue-jquery'
import { isAndroid } from 'mobile-device-detect'
/*
function OSInfoDev(){
		var uanaVigatorOs = navigator.userAgent;
		var AgentUserOs= uanaVigatorOs.replace(/ /g,'');
		var Ostxt=""; var OSName="";
		var OsVers=""; // This script sets OSName variable as follows: // "Windows" for all versions of Windows // "MacOS" for all versions of Macintosh OS // "Linux" for all versions of Linux // "UNIX" for all other UNIX flavors // "Unknown OS" indicates failure to detect the OS new function() { var OsNo = navigator.userAgent.toLowerCase(); jQuery.os = { Linux: /linux/.test(OsNo), Unix: /x11/.test(OsNo), Mac: /mac/.test(OsNo), Windows: /win/.test(OsNo) } }

		if(JQuery.os.Windows) {
			OSName = 'window';
		}else if (JQuery.os.Linux) {
			 if(AgentUserOs.indexOf("Android") != -1) { OSName = 'Android'; }
			else if(AgentUserOs.indexOf("BlackBerry9000") != -1) OSName="BlackBerry9000";
			else if(AgentUserOs.indexOf("BlackBerry9300") != -1) OSName="BlackBerry9300";
			else if(AgentUserOs.indexOf("BlackBerry9700") != -1) OSName="BlackBerry9700";
			else if(AgentUserOs.indexOf("BlackBerry9780") != -1) OSName="BlackBerry9780";
			else if(AgentUserOs.indexOf("BlackBerry9900") != -1) OSName="BlackBerry9900";
			else if(AgentUserOs.indexOf("BlackBerry;Opera Mini") != -1) OSName="Opera/9.80";
			else if(AgentUserOs.indexOf("Symbian/3") != -1) OSName="Symbian OS3";
			else if(AgentUserOs.indexOf("SymbianOS/6") != -1) OSName="Symbian OS6";
			else if(AgentUserOs.indexOf("SymbianOS/9") != -1) OSName="Symbian OS9";
			else if(AgentUserOs.indexOf("Ubuntu") != -1) OSName="Ubuntu";
			else if(AgentUserOs.indexOf("PDA") != -1) OSName="PDA";
			else if(AgentUserOs.indexOf("NintendoWii") != -1) OSName="Nintendo Wii";
			else if(AgentUserOs.indexOf("PSP") != -1) OSName="PlayStation Portable";
			else if(AgentUserOs.indexOf("PS2;") != -1) OSName="PlayStation 2";
			else if(AgentUserOs.indexOf("PLAYSTATION3") != -1) OSName="PlayStation 3";
			else OSName="Linux";

		} else if (JQuery.os.Unix) { OSName="UNIX"; }
			else if (JQuery.os.Mac) {
				if(AgentUserOs.indexOf("iPhone") != -1) {
				 OSName="iPhone"; }
			else if(AgentUserOs.indexOf("iPad") != -1) { OSName="iPad"; }
			else if(AgentUserOs.indexOf("MacOS") != -1) {
				if(AgentUserOs.indexOf("Macintosh") != -1) OSName="Macintosh";
			} else { OSName="MacOS"; }
		} else { OSName="Unknown OS"; }

		return OSName;
	}
	*/
export default {
  name: 'TryTodomathBottom',
  props:[],
  data () {
			const text = require('@/text/common/footer.js').default;
			const l10n = text[this.$store.state.lang]?text[this.$store.state.lang]:text['en'];

	    return {
				l10:l10n,
				downloadUrl:'',
				isAndroid: isAndroid
	    }
	},
	created(){
		this.setDownloadUrl();
	},
	methods:{
		setDownloadUrl(){
			if (isAndroid) {
				if (this.$store.state.lang == 'cn' && this.$store.state.cnDownloadUrl != '') {
						this.downloadUrl = this.$store.state.cnDownloadUrl;
				} else {
					this.downloadUrl = this.$store.state.googlePlayUrl;
				}
			} else {
				this.downloadUrl = this.$store.state.appStoreUrl;
			}

			this.$emit('set-url', this.downloadUrl);
			/*
			var osName='';
			var OsNo = navigator.userAgent.toLowerCase();
				JQuery.os = { Linux: /linux/.test(OsNo), Unix: /x11/.test(OsNo), Mac: /mac/.test(OsNo), Windows: /win/.test(OsNo) }
				osName = OSInfoDev();

				if(osName=='iPhone' || osName=='iPad'|| osName=='Macintosh'){

					// this.downloadUrl =  "https://itunes.apple.com/us/app/todo-k-2-math-practice/id666465255?mt=8";
					this.downloadUrl = this.$store.state.appStoreUrl;
				}else if(osName=='Android'){
					if (this.$store.state.lang == 'cn' && this.$store.state.cnDownloadUrl != '') {
						this.downloadUrl = this.$store.state.cnDownloadUrl;
					} else {
						this.downloadUrl = this.$store.state.googlePlayUrl;
					}

				}else{
					this.downloadUrl =  "https://itunes.apple.com/us/app/todo-k-2-math-practice/id666465255?mt=8";
				}

				this.$emit('set-url', this.downloadUrl);
				*/
		},
		goToDownloadPage(){
			window.open(this.downloadUrl);
		},
		handleClickAndroidDownload() {
			this.$emit('click-cn-androiddownload')
		}
	}
}
</script>
<style  scoped>
.content{
	width:100%;
	overflow: hidden;
	background-image: url("../../assets/footer/img-main-try-bg-m.png");
	background-size:2400px auto;
	height:764px;
}

.container{
	margin: 0 auto;
	padding:0px 35px;
	padding-top:100px;
	height: auto;
	min-height: 100px;
	width:720px;
	display: flex;
	flex-direction: column;
	align-items: center;

}
.container>img{
	width: 239px;
  height: 180px;
  object-fit: contain;

}
.container>p:first-of-type{
	font-size: 64px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -3px;
  text-align: center;
  color: #41403e;

  margin-top:28px;
}
.container>p:last-of-type{
	margin-top:16px;
	font-size: 34px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.35;
  letter-spacing: -1px;
  text-align: center;
  color: #41403e;

  margin-bottom: 84px;
}
.container>div{
	width: 100%;

}
#mobile-store-btn{
	width: 100%;
	height: 104px;
	font-size: 34px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 100px;
	letter-spacing: -1px;
	text-align: center;
	color: #41403e;
	border-radius: 10px;
	border: solid 3px #41403e;
	cursor: pointer;

}

</style>



// WEBPACK FOOTER //
// src/components/footer/TryTodomathMobile.vue